<!-- Spacer -->
<div class="zop-vertical-navigation-item-wrapper" [ngClass]="item.classes?.wrapper"></div>